var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBarrel = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 80",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.3 55.3c-1.5-.3-2.5-1.3-2.5-2.4V27.2c0-1.1 1-2.1 2.5-2.3 14.3-2.7 29.1-2.7 43.3 0 1.5.3 2.5 1.3 2.5 2.4V53c0 1.2-1 2.2-2.5 2.4-14.3 2.6-29.2 2.6-43.3 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 58.2c-7.4 0-14.7-.6-21.9-1.9-1.9-.4-3.2-1.8-3.2-3.3V27.3c0-1.7 1.4-3.1 3.3-3.2 14.1-2.7 29.2-2.7 43.6 0 1.9.4 3.2 1.7 3.2 3.3v25.7c0 1.7-1.3 3.1-3.2 3.3-7.1 1.3-14.4 1.9-21.9 1.9l.1-.1Zm.3-34.5c-7.4 0-14.7.6-21.8 2-1 0-1.7.7-1.7 1.4v25.7c0 .7.7 1.3 1.7 1.5 14.1 2.6 29 2.6 43.1 0 1-.2 1.7-.8 1.7-1.6V27c0-.7-.7-1.3-1.7-1.5-7-1.2-14.2-1.9-21.3-1.9v.1Z"
  })));
};
export default SvgBarrel;